// JavaScript для custom-list
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для custom-list
});
